// extracted by mini-css-extract-plugin
export default {"login":"Login_login__jXKF5","forms":"Login_forms__8iAIO"};